// Notes & Comments

export const GET_NOTES_CONTROL_CONFIG_START = 'GET_NOTES_CONTROL_CONFIG_START';
export const GET_NOTES_CONTROL_CONFIG_SUCCESS = 'GET_NOTES_CONTROL_CONFIG_SUCCESS';
export const GET_NOTES_CONTROL_CONFIG_FAIL = 'GET_NOTES_CONTROL_CONFIG_FAIL';

export const SAVE_NOTES_CONTROL_CONFIG_START = 'SAVE_NOTES_CONTROL_CONFIG_START';
export const SAVE_NOTES_CONTROL_CONFIG_SUCCESS = 'SAVE_NOTES_CONTROL_CONFIG_SUCCESS';
export const SAVE_NOTES_CONTROL_CONFIG_FAIL = 'SAVE_NOTES_CONTROL_CONFIG_FAIL';

export const GET_NOTES_START = 'GET_NOTES_START';
export const GET_NOTES_SUCCESS = 'GET_NOTES_SUCCESS';
export const GET_NOTES_FAIL = 'GET_NOTES_FAIL';

export const GET_NOTES_FILE_ASSOCIATIONS_START = 'GET_NOTES_FILE_ASSOCIATIONS_START';
export const GET_NOTES_FILE_ASSOCIATIONS_SUCCESS = 'GET_NOTES_FILE_ASSOCIATIONS_SUCCESS';
export const GET_NOTES_FILE_ASSOCIATIONS_FAIL = 'GET_NOTES_FILE_ASSOCIATIONS_FAIL';

export const CLEAR_NOTES_SUCCESS = 'CLEAR_NOTES_SUCCESS';
export const CLEAR_NOTES_START = 'CLEAR_NOTES_START';

export const GET_ALL_TRUCKING_COMPANIES_START = 'GET_ALL_TRUCKING_COMPANIES_START';
export const GET_ALL_TRUCKING_COMPANIES_SUCCESS = 'GET_ALL_TRUCKING_COMPANIES_SUCCESS';
export const GET_ALL_TRUCKING_COMPANIES_FAIL = 'GET_ALL_TRUCKING_COMPANIES_FAIL';

export const REASSIGN_NOTE_START = 'REASSIGN_NOTE_START';
export const REASSIGN_NOTE_SUCCESS = 'REASSIGN_NOTE_SUCCESS';
export const REASSIGN_NOTE_FAIL = 'REASSIGN_NOTE_FAIL';

export const ARCHIVE_NOTE_START = 'ARCHIVE_NOTE_START';
export const ARCHIVE_NOTE_SUCCESS = 'ARCHIVE_NOTE_SUCCESS';
export const ARCHIVE_NOTE_FAIL = 'ARCHIVE_NOTE_FAIL';

export const CREATE_NOTE_START = 'CREATE_NOTE_START';
export const CREATE_NOTE_SUCCESS = 'CREATE_NOTE_SUCCESS';
export const CREATE_NOTE_FAIL = 'CREATE_NOTE_FAIL';

export const ASSIGN_NOTE_TO_TASK_START = 'ASSIGN_NOTE_TO_TASK_START';
export const ASSIGN_NOTE_TO_TASK_SUCCESS = 'ASSIGN_NOTE_TO_TASK_SUCCESS';
export const ASSIGN_NOTE_TO_TASK_FAIL = 'ASSIGN_NOTE_TO_TASK_FAIL';

export const CREATE_NOTE_COMMENT_START = 'CREATE_NOTE_COMMENT_START';
export const CREATE_NOTE_COMMENT_SUCCESS = 'CREATE_NOTE_COMMENT_SUCCESS';
export const CREATE_NOTE_COMMENT_FAIL = 'CREATE_NOTE_COMMENT_FAIL';

export const EXPORT_NOTES_TO_PDF_START = 'EXPORT_NOTES_TO_PDF_START';
export const EXPORT_NOTES_TO_PDF_SUCCESS = 'EXPORT_NOTES_TO_PDF_SUCCESS';
export const EXPORT_NOTES_TO_PDF_FAIL = 'EXPORT_NOTES_TO_PDF_FAIL';

export const EXPORT_NOTES_TO_EXCEL_START = 'EXPORT_NOTES_TO_EXCEL_START';
export const EXPORT_NOTES_TO_EXCEL_SUCCESS = 'EXPORT_NOTES_TO_EXCEL_SUCCESS';
export const EXPORT_NOTES_TO_EXCEL_FAIL = 'EXPORT_NOTES_TO_EXCEL_FAIL';

// App Internal Note and Comments Constants
export const ADD_NOTE_MODAL_STATE_CHANGE = 'ADD_NOTE_MODAL_STATE_CHANGE';

// Types

export const GET_NOTE_TEMPLATES_START = 'GET_NOTE_TEMPLATES_START';
export const GET_NOTE_TEMPLATES_SUCCESS = 'GET_NOTE_TEMPLATES_SUCCESS';
export const GET_NOTE_TEMPLATES_FAIL = 'GET_NOTE_TEMPLATES_FAIL';

export const GET_NOTE_DISPOSITIONS_START = 'GET_NOTE_DISPOSITIONS_START';
export const GET_NOTE_DISPOSITIONS_SUCCESS = 'GET_NOTE_DISPOSITIONS_SUCCESS';
export const GET_NOTE_DISPOSITIONS_FAIL = 'GET_NOTE_DISPOSITIONS_FAIL';

export const GET_INSUREDS_PROSPECTS_START = 'GET_INSUREDS_START';
export const GET_INSUREDS_PROSPECTS_SUCCESS = 'GET_INSUREDS_SUCCESS';
export const GET_INSUREDS_PROSPECTS_FAIL = 'GET_INSUREDS_FAIL';

export const GET_POLICIES_START = 'GET_POLICIES_START';
export const GET_POLICIES_SUCCESS = 'GET_POLICIES_SUCCESS';
export const GET_POLICIES_FAIL = 'GET_POLICIES_FAIL';

export const GET_TASKS_START = 'GET_TASKS_START';
export const GET_TASKS_SUCCESS = 'GET_TASKS_SUCCESS';
export const GET_TASKS_FAIL = 'GET_TASKS_FAIL';

export const GET_CLAIMS_START = 'GET_CLAIMS_START';
export const GET_CLAIMS_SUCCESS = 'GET_CLAIMS_SUCCESS';
export const GET_CLAIMS_FAIL = 'GET_CLAIMS_FAIL';

export const GET_NOTE_TYPES_START = 'GET_NOTE_TYPES_START';
export const GET_NOTE_TYPES_SUCCESS = 'GET_NOTE_TYPES_SUCCESS';
export const GET_NOTE_TYPES_FAIL = 'GET_NOTE_TYPES_FAIL';

export const CREATE_NOTE_TYPE_START = 'CREATE_NOTE_TYPE_START';
export const CREATE_NOTE_TYPE_SUCCESS = 'CREATE_NOTE_TYPE_SUCCESS';
export const CREATE_NOTE_TYPE_FAIL = 'CREATE_NOTE_TYPE_FAIL';

export const GET_CONTACT_PHONES_START = 'CREATE_CONTACT_PHONES_START';
export const GET_CONTACT_PHONES_SUCCESS = 'CREATE_CONTACT_PHONES_SUCCESS';
export const GET_CONTACT_PHONES_FAIL = 'CREATE_CONTACT_PHONES_FAIL';

export const GET_REMINDER_EMAILS_START = 'CREATE_REMINDER_EMAILS_START';
export const GET_REMINDER_EMAILS_SUCCESS = 'CREATE_REMINDER_EMAILS_SUCCESS';
export const GET_REMINDER_EMAILS_FAIL = 'CREATE_REMINDER_EMAILS_FAIL';

export const TOGGLE_NOTE_PIN_START = 'TOGGLE_NOTE_PIN_START';
export const TOGGLE_NOTE_PIN_SUCCESS = 'TOGGLE_NOTE_PIN_SUCCESS';
export const TOGGLE_NOTE_PIN_FAIL = 'TOGGLE_NOTE_PIN_FAIL';

export const UPDATE_NOTE_START = 'UPDATE_NOTE_START';
export const UPDATE_NOTE_SUCCESS = 'UPDATE_NOTE_SUCCESS';
export const UPDATE_NOTE_FAIL = 'UPDATE_NOTE_FAIL';

export const GET_MENTIONS_USERS_START = 'GET_MENTIONS_USERS_START';
export const GET_MENTIONS_USERS_SUCCESS = 'GET_MENTIONS_USERS_SUCCESS';
export const GET_MENTIONS_USERS_FAIL = 'GET_MENTIONS_USERS_FAIL';
